import Cookies from 'js-cookie'

let TokenKey="BUSER"
let USERINFO="USERINFO"
const inFifteenMinutes = new Date(new Date().getTime() + 7*24 * 60 * 60 * 1000)
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,{ expires: inFifteenMinutes })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function removeInfo() {
  return Cookies.remove(USERINFO)
}

export function getInfo() {
  let data=typeof(Cookies.get(USERINFO));
  if(data=="string"){
  	  return JSON.parse(Cookies.get(USERINFO))
  }else{
  	  return Cookies.get(USERINFO);
  }
}

export function setInfo(userInfo) {
  return Cookies.set(USERINFO, userInfo,{ expires: inFifteenMinutes })
}